export default __webpack_public_path__ + "static/media/canva.b96f915b.svg";